import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/status';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/ff8a1169-fcc5-4f07-a44e-64d7b6f625dd?version=eec9ea68-e578-4ff9-adda-0823886e066f&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '2',
    bussinessErrorVariant: 'userNotFound',
    message:
      'Não foi possível acessar sua conta. Para maiores informações, entre em contato com a central de atendimento Smiles.',
  },
  {
    code: '3',
    bussinessErrorVariant: 'notValid',
    message: 'Conta inválida',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
